module.exports = __webpack_public_path__ + "img/transaction.9dad23f2.png";